// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"be7da588","35":"b51134ba","126":"6141da93","143":"42829287","148":"50362f28","295":"dafaa43a","453":"71005ac6","749":"0df827c2","784":"bae4e3ff","815":"8bec0efd","893":"c9a84989","930":"60dfd90a","981":"7cfe0410"}[chunkId] + ".chunk.js";
};